import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import registerServiceWorker from "./registerServiceWorker";
import { createStore, compose, applyMiddleware, combineReducers } from "redux";
import { Provider } from "react-redux";
import thunk from "redux-thunk";
import 'antd/dist/antd.css';
import './index.css';
import { ConfigProvider } from 'antd';
import viVN from 'antd/lib/locale/vi_VN';
import '@material-design-icons/font';

import authReducer from "./store/reducers/auth";
// import cartReducer from "./store/reducers/cart";
import userReducer from "./store/reducers/user";
import ticketReducer from "./store/reducers/ticketData";

const composeEnhances = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const rootReducer = combineReducers({
    auth: authReducer,
    // cart: cartReducer,
    user: userReducer,
    ticketData:ticketReducer
});

const store = createStore(rootReducer, composeEnhances(applyMiddleware(thunk)));
// localStorage.setItem("token", Cookies.get('access_token'));
const app = (
  <Provider store={store}>
    <ConfigProvider locale={viVN}>
    <App />
    </ConfigProvider>
  </Provider>
);

ReactDOM.render(app, document.getElementById("root"));
registerServiceWorker();
